const LOAD_DETAIL_EMPLOYERS           = 'LOAD_DETAIL_EMPLOYERS'
const LOAD_DETAIL_EMPLOYERS_SUCCESS   = 'LOAD_DETAIL_EMPLOYERS_SUCCESS'
const LOAD_DETAIL_EMPLOYERS_FAILED    = 'LOAD_DETAIL_EMPLOYERS_FAILED'
const UNMOUNT_DETAIL_EMPLOYERS        = 'UNMOUNT_DETAIL_EMPLOYERS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const employersDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_EMPLOYERS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_EMPLOYERS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_EMPLOYERS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_EMPLOYERS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default employersDetailReducer;